import { gsap } from 'gsap'

export class Grid {

  isCallable() {
    return window.innerWidth > 1024
  }
  init() {

    const gridContainer = document.getElementById('bg-grid');
    const gridSize = 25;
    const rows = Math.floor(window.innerHeight / gridSize);
    const cols = Math.floor(window.innerWidth / gridSize);

    const maxLines = Math.max(rows, cols);

    for (let i = 0; i < maxLines; i++) {
      const lineVertical = document.createElement('div');
      lineVertical.classList.add('line', 'vertical');
      lineVertical.style.left = `${i * gridSize}px`;
      gridContainer.appendChild(lineVertical);

      const lineHorizontal = document.createElement('div');
      lineHorizontal.classList.add('line', 'horizontal');
      lineHorizontal.style.top = `${i * gridSize}px`;
      gridContainer.appendChild(lineHorizontal);
    }

    gsap.set(".line.horizontal", {width: 0, opacity: 0});
    gsap.set(".line.vertical", {height: 0, opacity: 0});

    gsap.to(".line.horizontal", {
      width: window.innerWidth,
      opacity: 0.03,
      duration: 2,
      ease: "power4.out"
    })

    gsap.to(".line.vertical", {
      height: window.innerHeight,
      duration: 2,
      opacity: 0.03,
      stagger: 0.02,
      ease: "power4.out"
    });

    window.addEventListener('resize', () => {
      gsap.to(".line.horizontal", {
        width: window.innerWidth,
        duration: 2,
        opacity: 0.03,
        ease: "power4.out"
      })

      gsap.to(".line.vertical", {
        height: window.innerHeight,
        duration: 2,
        opacity: 0.03,
        ease: "power4.out"
      });

      const rows = Math.floor(window.innerHeight / gridSize);
      const cols = Math.floor(window.innerWidth / gridSize);
      const maxLines = Math.max(rows, cols);

      if (document.querySelectorAll('.line.horizontal').length < maxLines) {
        for (let i = document.querySelectorAll('.line.horizontal').length; i < maxLines; i++) {
          const lineHorizontal = document.createElement('div');
          lineHorizontal.classList.add('line', 'horizontal');
          lineHorizontal.style.top = `${i * gridSize}px`;
          gridContainer.appendChild(lineHorizontal);
        }
      }
      if (document.querySelectorAll('.line.vertical').length < maxLines) {
        for (let i = document.querySelectorAll('.line.vertical').length; i < maxLines; i++) {
          const lineVertical = document.createElement('div');
          lineVertical.classList.add('line', 'vertical');
          lineVertical.style.left = `${i * gridSize}px`;
          gridContainer.appendChild(lineVertical);
        }
      }

    })
  }
}
